import PostImg1 from "../assets/images/resources/postImg1-1.jpg";
import PostImg2 from "../assets/images/resources/postImg1-2.jpg";
import PostImg3 from "../assets/images/resources/postImg1-3.jpg";
import PostImg4 from "../assets/images/resources/postImg1-4.jpg";
import PostImg5 from "../assets/images/resources/postImg1-5.jpg";
import PostImg6 from "../assets/images/resources/postImg1-6.jpg";

export const posts = [
  {
    id: 1,
    postImg: PostImg1,
    postDate: "January 21, 2022",
    postDateLink: "#",
    postTitle: "Spring Which I Enjoy With For Effective Agile Team",
    postLink: "#",
    postAuthor: "Berline Tokyo",
    postAuthorLink: "#",
  },
  {
    id: 2,
    postImg: PostImg2,
    postDate: "February 18, 2022",
    postDateLink: "#",
    postTitle: "But some of the current projects that make",
    postLink: "#",
    postAuthor: "John Doe",
    postAuthorLink: "#",
  },
  {
    id: 3,
    postImg: PostImg3,
    postDate: "April 05, 2022",
    postDateLink: "#",
    postTitle: "Project that began allow second phase in worth",
    postLink: "#",
    postAuthor: "Martha Beth",
    postAuthorLink: "#",
  },
  {
    id: 4,
    postImg: PostImg4,
    postDate: "April 05, 2022",
    postDateLink: "#",
    postTitle: "Multiethnic colleagues sitting at desk looking",
    postLink: "#",
    postAuthor: "Martha Beth",
    postAuthorLink: "#",
  },
  {
    id: 5,
    postImg: PostImg5,
    postDate: "January 21, 2022",
    postDateLink: "#",
    postTitle: "Shot of two work colleage using a digital tablet",
    postLink: "#",
    postAuthor: "Berline Tokyo",
    postAuthorLink: "#",
  },
  {
    id: 6,
    postImg: PostImg6,
    postDate: "April 05, 2022",
    postDateLink: "#",
    postTitle: "Beautiful Specialist with Short Pink Hair Talks",
    postLink: "#",
    postAuthor: "Martha Beth",
    postAuthorLink: "#",
  },
];
